import React, { Component } from "react";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import axios from "axios";
import styled from "styled-components";
import { media } from "../../utils/style";
import Headline from "../../components/Headline";
import Description from "../../components/Description";
import Note from "../../components/Note";
import ResetPasswordForm from "../../components/ResetPasswordForm";
import PasswordUpdated from "../../components/PasswordUpdated";
import PasswordFail from "../../components/PasswordFail";

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 24px auto 25%;
  max-width: 900px;
  padding: 0 20px;

  ${media.tablet`
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin: 75px auto 22%;
  `};
`;

const CustomDescription = styled(Description)`
  margin-top: 7px;

  ${media.tablet`
    margin-top: 12px;
  `};
`;

const CustomNote = styled(Note)`
  margin-top: 10px;
  font-size: 14px;

  ${media.tablet`
    margin-top: 50px;
  `};
`;

const Copy = styled.div`
  margin: 0 0 30px;
  max-width: 365px;
  padding: 0;

  ${media.phone`
    align-self: center;
  `};

  ${media.tablet`
    align-self: center;
  `};

  ${media.desktop`
    align-self: flex-start;
  `};
`;

const PasswordUtility = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: column nowrap;
  min-height: 425px;

  ${media.tablet`
    width: 100%;
  `};
  ${media.desktop`
    width: 55%;
  `};
`;

const div = styled.div`
  opacity: 0.5;
`;

class Forgot extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      hideSuccess: true,
      hideError: true
    };
  }

  handleSubmit(data, resetForm) {
    const { password, confirmPassword } = data;
    const passwordResetToken = queryString.parse(this.props.location.search)
      .token;
    axios
      .patch(`${process.env.REACT_APP_HOST_URL}/users/password_reset`, {
        password: password,
        password_confirmation: confirmPassword,
        password_reset_token: passwordResetToken
      })
      .then(response => {
        console.log(response);
        //resetForm();

        this.setState({
          hideSuccess: false,
          hideError: true
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          hideError: false
        });
      });
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Blast - Reset Password</title>
        </Helmet>

        <Wrapper>
          <Copy>
            <Headline>Create a New Password</Headline>
            <CustomDescription>
              Set your new Blast password now.
            </CustomDescription>
            <CustomNote>
              You must select a password that you have not used before, it must
              be a minimum of eight characters long and must include
              alphabetical, numeric, uppercase, and lowercase characters.
            </CustomNote>
          </Copy>
          <PasswordUtility>
            {this.state.hideSuccess && (
              <ResetPasswordForm handleSubmit={this.handleSubmit} />
            )}
            {!this.state.hideSuccess && <PasswordUpdated />}
            {!this.state.hideError && <PasswordFail />}
          </PasswordUtility>
        </Wrapper>
      </div>
    );
  }
}

export default Forgot;



// WEBPACK FOOTER //
// ./src/pages/Reset/index.jsx